@if (info) {
  <h2 mat-dialog-title class="text-center">ALERT</h2>
}

@if (info) {
  <div mat-dialog-content>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12" class="text-center">
          @if (info?.isBlockedByFamily || info?.isBlockedByFines || info?.isBlockedByOverdues) {
            <div>
              <p>Your account is being blocked due to:</p>
              @if (info?.isBlockedByFamily) {
                <div class="bold">Family</div>
              }
              <br />
              @if (info?.isBlockedByFamily) {
                <div>{{ info?.msgBlockedByFamily }}</div>
              }
              @if (info?.isBlockedByFines) {
                <div class="bold">Outstanding Fines</div>
              }
              <br />
              @if (info?.isBlockedByFines) {
                <div>{{ info?.msgBlockedByFines }}</div>
              }
              @if (info?.isBlockedByOverdues) {
                <div class="bold">Outstanding Overdues</div>
              }
              <br />
              @if (info?.isBlockedByOverdues) {
                <div>{{ info?.msgBlockedByOverdues }}</div>
              }
            </div>
          }
          @if (summary !== '') {
            <div class="text-center">{{ summary }}</div>
          }
        </div>
      </div>
    </div>
  </div>
}

<div mat-dialog-actions align="end">
  <button role="button" type="button" aria-label="Yes" mat-button cdkFocusInitial (click)="close()">
    OK
  </button>
</div>
